module.exports = __webpack_public_path__ + "static/media/blogfullimg.90dc29f2.jpg";